import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    getWeatherCalendarApi,
    getWeatherDictTreeApi,
    getWeatherByDateApi,
    getWeatherByIdApi,
    getObservationsDataApi,
    postWeatherCommentApi,
    putWeatherCommentApi,
    postObservationsDataApi,
} from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    calendarInfo: null, // 被点击的日历信息
    calendarData: null, // 日历上当前范围内显示的总结填写信息
    dictData: null, // 数据字典
    listData: null, // 回显数据
    locationName: '', // location 名称
    locationId: '', // location id
    save: false,
    id: '',
}

/* 获取日历上的数据 */
export const getWeatherCalendarAction = createAsyncThunk(
    'WeatherSlice/getWeatherCalendarAction',
    async (params, thunkAPI) => {
        try {
            const { data } = await getWeatherCalendarApi(params)
            return data.data
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据字典 */
export const getWeatherDictDataAction = createAsyncThunk(
    'WeatherSlice/getWeatherDictDataAction',
    async (dictType, thunkAPI) => {
        const observationsTypeDataDict = getWeatherDictTreeApi(dictType[0])
        const unitTypeDataDict = getWeatherDictTreeApi(dictType[1])
        const useTypeDataDict = getWeatherDictTreeApi(dictType[2])
        const useSwellHeight = getWeatherDictTreeApi(dictType[3])
        const useWindUnit = getWeatherDictTreeApi(dictType[4])
        const useSituationUnit = getWeatherDictTreeApi(dictType[5])
        return Promise.all([observationsTypeDataDict, unitTypeDataDict, useTypeDataDict, useSwellHeight, useWindUnit, useSituationUnit])
            .then(dictData => dictData)
            .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
    }
)

/* 通过日期获取 id */
export const getWeatherByDateAction = createAsyncThunk(
    'WeatherSlice/getWeatherByDateAction',
    async (listDataParams, thunkAPI) => {
        try {
            const commentData = await getWeatherByDateApi(listDataParams) // 通过日期查询 id
            return commentData?.data?.data?.id
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 获取数据 */
export const getWeatherDataAction = createAsyncThunk('WeatherSlice/getWeatherDataAction', async (id, thunkAPI) => {
    const commentData = getWeatherByIdApi(id) // 通过 id 查询
    const observationsData = getObservationsDataApi(id)
    return Promise.all([commentData, observationsData])
        .then(listData => listData)
        .catch(error => thunkAPI.dispatch(BoundarySlice.actions.addError(error)))
})

/* 保存数据 */
export const postWeatherDataAction = createAsyncThunk(
    'WeatherSlice/postWeatherDataAction',
    async ({ id, commentParams, observationsParams, isCopyData }, { dispatch }) => {
        let vid
        try {
            if (!id || isCopyData) {
                const commentData = await postWeatherCommentApi(commentParams) // 新增
                vid = commentData.data.data.id
                await postObservationsDataApi(observationsParams, vid)
                dispatch(WeatherSlice.actions.addId(vid))
                return { isTrue: true, id: vid } // 已保存状态
            } else {
                vid = id
                await putWeatherCommentApi(commentParams, id) // 修改
                await postObservationsDataApi(observationsParams, id)
                return { isTrue: true, id } // 已保存状态
            }
        } catch (error) {
            dispatch(WeatherSlice.actions.addId(vid))
            dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

export const WeatherSlice = createSlice({
    name: 'WeatherSlice',
    initialState,
    reducers: {
        /* 日历点击信息 */
        addCalendarInfo: (state, action) => {
            state.calendarInfo = action.payload
        },
        /* 清空日历与详情页信息 */
        clearListData: state => {
            state.listData = null
            state.calendarData = null
            state.save = false
            state.id = ''
        },
        /* 当前日历主 id */
        addId: (state, action) => {
            state.id = action.payload
        },
        /* location 名称 */
        addLocationName: (state, action) => {
            state.locationName = action.payload
        },
        /* location id */
        addLocationId: (state, action) => {
            state.locationId = action.payload
        },
    },
    extraReducers: {
        /* 获取日历上的数据 */
        [getWeatherCalendarAction.fulfilled.type]: (state, action) => {
            state.calendarData = action.payload
        },

        /* 处理数据字典 */
        [getWeatherDictDataAction.fulfilled.type]: (state, action) => {
            state.dictData = action.payload
        },

        /* 提交总结数据 */
        [postWeatherDataAction.fulfilled.type]: (state, action) => {
            state.save = action.payload
        },

        /* 获取回显数据 */
        [getWeatherDataAction.fulfilled.type]: (state, action) => {
            state.listData = action.payload
        },

        /* 通过日期，获取 id */
        [getWeatherByDateAction.fulfilled.type]: (state, action) => {
            state.id = action.payload
        },
    },
})
